import { provide, ref, reactive, getCurrentInstance, computed } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { getAmount } from '@/utils/amount';
import store from '@/store';
/* 
TODO --- 建立dialog ---

*在getDialogData建立資料 ---
[dialogName]:{
  dialogTemplate: vue檔名 / 模板
  dialogName: unique name，以方便在dialog template模板中做個別處理
  dialogTitle: 標題名,inject('title')
  dialogContent: 內文,inject('content')
  dialogImage: 圖片,inject('image')
  dialogList: 陣列,inject('list'),需解構{ list }
  submitFunc: 自定義的methods function/需搭配dialog的submit使用
  style: {
    width: 寬度,預設400px
    height: 高度,預設400px
    dialogRows: 可設定grid-rows(string), 預設為(50px auto 60px)(title-body-footer)
    confirmButtonText: confirmButton文字，預設寫在各模板裡面
    confirmButtonColor: confirmButton顏色，預設寫在各模板裡面
  }
  cusProps: 自定義其他屬性,inject('cusProps'),需解構{ cusProps }
  hideClose: 要不要顯示叉叉關閉(預設false)
}
!以上只有dialogTemplate必填，其他皆選填


*使用dialog ---
1. import dialogTemplate.vue ： component: { dialogTemplate }
!dialogTemplate.vue必須使用<cus-dialog></cus-dialog>建立內容
2. import { useDialog }
3. 在setup()執行useDialog() 
可解構的參數有{ dialogVisible, dialogTemplate, dialogName, openDialog, doOpenDialog, closeDialog, getDialogData, openHeaderDialog,
 getHeaderDialogData, }
dialogVisible: 控制dialog開關的boolean值
dialogTemplate: 在template中使用：<component :is="dialogTemplate"></component> 控制使用哪個模板
dialogName: unique name，可以用此判斷目前是使用哪個dialog
openDialog: function，開啟的是getDialogData定義的彈窗，需帶入自定義的參數(dialogName)
doOpenDialog: function，如果需要動態增加dialog參數，須先使用getDialogData獲取已設定data並新增參數，再使用doOpenDialog開啟彈窗並帶入新的data
getDialogData: function，執行getDialogData()帶入自定義的dialogName，可獲取設定的dialog資料(點餐結帳等頁面使用)
closeDialog: function，可關閉彈窗
openHeaderDialog: function，開啟的是getHeaderDialogData定義的彈窗，需帶入自定義的參數(dialogName)
getHeaderDialogData: function，執行getHeaderDialogData()帶入自定義的dialogName，可獲取設定的dialog資料(掛單訂單等頁面使用)
!以上dialogTemplate,openDialog, 必須return，其餘有使用到再return即可


* 使用submitFunc ---
在子元素的dialog.vue的setup() inject('submit')
子元素執行submit(val) 等同 父元素執行submitFunc(val)

* MoreSelect ---
cusProps.type = single ==> 單選(為預設，可以不寫)
cusProps.type = multiple ==> 多選，選擇後資料為陣列

*/

const useDialog = () => {
  //建立參數
  const dialogVisible = ref(false);
  const dialogTemplate = ref(null);
  const dialogName = ref(null);
  const title = ref(null);
  const content = ref(null);
  const image = ref(null);
  const funcName = ref(null);
  const hideClose = ref(false);
  let listData = reactive({});
  let styleData = reactive({});
  let cus = reactive({});
  let chooseVal = reactive({});
  //打開彈窗
  const doOpenDialog = (dialog) => {
    // console.log(dialog);
    dialogTemplate.value = dialog.dialogTemplate;
    dialogName.value = dialog.dialogName;
    title.value = dialog.dialogTitle;
    content.value = dialog.dialogContent;
    image.value = dialog.dialogImage;
    funcName.value = dialog.submitFunc;
    hideClose.value = dialog.hideClose;
    listData.list = dialog.dialogList;
    styleData.style = dialog.style;
    cus.cusProps = dialog.cusProps;
    dialogVisible.value = true;
  };
  const openDialog = (dialogName, cusProps = {}, newDialogData) => {
    closeDialog();
    const data = getDialogData(dialogName);
    if (data.cusProps) {
      data.cusProps = { ...data.cusProps, ...cusProps };
    } else {
      data.cusProps = cusProps;
    }
    if (newDialogData) {
      if (newDialogData.dialogTitle) data.dialogTitle = newDialogData.dialogTitle;
      if (newDialogData.dialogContent) data.dialogContent = newDialogData.dialogContent;
      if (newDialogData.dialogImage) data.dialogImage = newDialogData.dialogImage;
      if (newDialogData.submitFunc) data.submitFunc = newDialogData.submitFunc;
      if (newDialogData.hideClose) data.hideClose = newDialogData.hideClose;
      if (newDialogData.dialogList) data.dialogList = newDialogData.dialogList;
      if (newDialogData.style) data.style = newDialogData.style;
    }
    doOpenDialog(data);
  };
  //關閉彈窗
  const closeDialog = () => {
    console.log("closeDialog name=" + dialogName.value);

    // Prevent multiple calls
    if (dialogVisible.value === false) return;

    // Handle dialog close actions based on dialog name
    if (dialogName.value === 'view') {
      store.commit('menuItem/SET_IS_VIEW', false);
    } 
    // Handle noticeScan dialog close
    else if (dialogName.value === 'noticeScan') {
      console.log('noticeScan doCancelScan in closeDialog');
      store.dispatch('member/doCancelScan', cus.cusProps.scanType);
    }
    // Handle checkout dialogs close
    else if (['checkoutScan', 'checkoutThirdPartyScan'].includes(dialogName.value)) {
      console.log('checkout dialog close in closeDialog');
      store.dispatch('checkout/doCancelCheckout', cus.cusProps.order_id);
    }
    
    // Reset dialog state
    dialogTemplate.value = null;
    dialogVisible.value = false;
  };
  //彈窗內執行submit
  const { proxy } = getCurrentInstance();
  const submit = (val) => {
    chooseVal.data = val;
    proxy[funcName.value](chooseVal.data);
  };

  //dialog data
  //!登入/點餐/結帳頁面 相關彈窗資料 ---------------------------------------------------------
  const { chooseTab, getNote, chooseQuantity, chooseDiscount, getDetail, getItemPrice } = useGetters('menuItem', [
    'chooseTab',
    'getNote',
    'chooseQuantity',
    'chooseDiscount',
    'getDetail',
    'getItemPrice',
  ]);
  const { getTabList, getDiscountList, getDetailBtns, getEntertainList, getAllAddOnList, getTicketList } = useGetters(
    'list',
    ['getTabList', 'getDiscountList', 'getDetailBtns', 'getEntertainList', 'getAllAddOnList', 'getTicketList']
  );
  const { getMemberInformation, getDayungsPayment, getMemberTicket } = useGetters('member', [
    'getMemberInformation',
    'getDayungsPayment',
    'getMemberTicket',
  ]);
  const { getNews, getMemo } = useGetters('order', ['getNews', 'getMemo']);
  const chooseEntertain = useGetters('checkout', ['chooseEntertain']);
  const getTax = useGetters('checkout', ['getTax']);
  const { computeUnpaid } = getAmount();
  const getDialogData = (val) => {
    const data = computed(() => {
      return {
        //登入畫面相關彈窗-------------------------------------------------------
        inputCash: {
          dialogTemplate: 'Computer',
          dialogName: 'inputCash',
          dialogTitle: '零用金',
          submitFunc: 'handleCash',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: proxy.cash, //data in Login.vue
            hasHundred: true,
          },
        },
        //輸入不同雜支項目的金額
        inputCost: {
          dialogTemplate: 'Computer',
          dialogName: 'inputCost',
          submitFunc: 'handleCostInput',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            hasHundred: true,
            disableMin: -1,
          },
        },
        //訂單相關彈窗-------------------------------------------------------
        consumer: {
          dialogTemplate: 'InputInfo',
          dialogName: 'consumer',
          dialogTitle: '訂購人資訊',
          submitFunc: 'handleConsumer',
          style: {
            height: 'auto',
          },
          cusProps: {
            init: proxy.orderInformation?.consumer, //data in OrderInfo.vue
            source: proxy.orderInformation?.source, //data in OrderInfo.vue
          },
        },
        //掃描相關彈窗-------------------------------------------------------
        noticeScan: {
          dialogTemplate: 'Alert',
          dialogName: 'noticeScan',
          dialogImage: require('@/assets/images/icon-scan.png'),
          style: {
            width: '265px',
            height: '280px',
            dialogRows: 'auto',
            hideFooter: true,
          },
        },
        checkoutScan: {
          dialogTemplate: 'Alert',
          dialogName: 'checkoutScan',
          dialogImage: require('@/assets/images/icon-scan.png'),
          style: {
            width: '265px',
            height: '280px',
            dialogRows: 'auto',
            hideFooter: true,
          },
          hideClose: true,
        },
        checkoutThirdPartyScan: {
          dialogTemplate: 'Alert',
          dialogName: 'checkoutThirdPartyScan',
          dialogImage: require('@/assets/images/icon-scan.png'),
          style: {
            width: '265px',
            height: '280px',
            dialogRows: 'auto',
            hideFooter: true,
          },
        },
        //大苑子支付相關彈窗-------------------------------------------------------
        wantCardAdd: {
          dialogTemplate: 'Computer',
          dialogName: 'wantCardAdd',
          dialogTitle: '加值金額',
          submitFunc: 'handleWantCardMoney',
          style: {
            width: '340px',
            height: '580px',
            confirmButtonText: '加值',
            confirmButtonColor: 'green',
          },
          cusProps: {
            init: 0,
            hasNote: true,
            note: '(以佰元為單位)',
            hasHundred: true,
            disableMin: 99,
          },
        },
        wantCardRefund: {
          dialogTemplate: 'Computer',
          dialogName: 'wantCardRefund',
          dialogTitle: '退值金額',
          submitFunc: 'handleWantCardMoney',
          style: {
            width: '340px',
            height: '580px',
            confirmButtonText: '退值',
            confirmButtonColor: 'green',
          },
          cusProps: {
            init: 0,
            hasNote: true,
            note: '(以佰元為單位)',
            hasHundred: true,
            disableMin: 99,
          },
        },
        completeAddCard: {
          dialogTemplate: 'Alert',
          dialogName: 'completeAddCard',
          dialogContent: `交易成功<br/>餘額<span class="green-text-large" > ${getDayungsPayment.value?.want_card?.balance} </span>元`,
          dialogImage: require('@/assets/images/icon-pass.png'),
          submitFunc: 'handleCompleteAddCard',
          style: {
            width: '265px',
            height: '320px',
            dialogRows: 'auto 60px',
            confirmButtonText: '完成',
          },
          hideClose: true,
        },
        completeCardLinkDeduct: {
          dialogTemplate: 'Alert',
          dialogName: 'completeCardLinkDeduct',
          dialogContent: `自動加值成功<br/>餘額<span class="green-text-large" > ${getDayungsPayment.value?.want_card?.balance} </span>元`,
          dialogImage: require('@/assets/images/icon-pass.png'),
          submitFunc: 'handleCompleteCardLinkDeduct',
          style: {
            width: '265px',
            height: '320px',
            dialogRows: 'auto 60px',
            confirmButtonText: '完成',
          },
          hideClose: true,
        },
        useWantCardPoint: {
          dialogTemplate: 'Computer',
          dialogName: 'useWantCardPoint',
          dialogTitle: '折抵點數',
          submitFunc: 'handleUsePoint',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: 0,
            hasNote: true,
            hasSpeedBtn: true,
            speedNumber:
              getDayungsPayment.value?.want_card_point?.balance > computeUnpaid.value
                ? computeUnpaid.value
                : getDayungsPayment.value?.want_card_point?.balance,
            note: `(目前點數：${getDayungsPayment.value?.want_card_point?.balance})`,
            buttonText: '全部折抵',
          },
        },
        cardInfo: {
          dialogTemplate: 'Information',
          dialogName: 'cardInfo',
          dialogTitle: '旺卡/會員卡資訊',
          submitFunc: 'reScan',
          cusProps: {
            dayungs_card: getDayungsPayment.value,
            member_card: getMemberInformation.value,
            getMemberTicket: getMemberTicket.value,
          },
          style: {
            height: 'auto',
            minHeight: '400px',
          },
        },
        // memberInfo: {
        //   dialogTemplate: 'Information',
        //   dialogName: 'memberInfo',
        //   dialogTitle: '會員資訊',
        //   dialogContent: `姓名：${getMemberInformation.value?.name}<br />編號：${getMemberInformation.value?.card_no}<br />等級：${getMemberInformation.value?.level_description}`,
        //   submitFunc: 'reScan',
        //   cusProps: {
        //     member_card: getMemberInformation.value,
        //   },
        //   style: {
        //     height: 'auto',
        //   },
        // },
        // memberInfoFirstTime: {
        //   dialogTemplate: 'Information',
        //   dialogName: 'memberInfoFirstTime',
        //   dialogTitle: '會員資訊',
        //   dialogContent: `姓名：${getMemberInformation.value?.name}<br />編號：${getMemberInformation.value?.card_no}<br />等級：${getMemberInformation.value?.level_description}`,
        //   submitFunc: 'addRecommend',
        //   cusProps: {
        //     member_card: getMemberInformation.value,
        //   },
        //   style: {
        //     height: 'auto',
        //   },
        // },
        //點餐畫面相關彈窗-------------------------------------------------------
        moreTab: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'moreTab',
          dialogTitle: '所有分類',
          dialogList: getTabList.value,
          submitFunc: 'selectTab',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: chooseTab.value,
          },
        },
        quantity: {
          dialogTemplate: 'Computer',
          dialogName: 'quantity',
          dialogTitle: '數量',
          submitFunc: 'handleQuantity',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: chooseQuantity.value < 10 ? 10 : chooseQuantity.value,
          },
        },
        ticketList: {
          dialogTemplate: 'TicketList',
          dialogName: 'ticketList',
          dialogTitle: '電子券',
          style: {
            width: '100%',
            height: '99vh',
          },
        },
        selectTicketEvent: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'selectTicketEvent',
          dialogTitle: '套餐',
          dialogList: getTicketList.value,
          submitFunc: 'handleSelectTicketEvent',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: null,
          },
        },
        view: {
          dialogTemplate: 'ViewTable',
          dialogName: 'view',
          dialogTitle: '瀏覽',
          style: {
            width: '100%',
            height: '99vh',
          },
        },
        promotionNews: {
          dialogTemplate: 'Information',
          dialogName: 'promotionNews',
          dialogTitle: '資訊欄',
          dialogContent: getNews.value,
        },
        //商品品項相關彈窗-------------------------------------------------------
        selectReplaceItem: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'selectReplaceItem',
          dialogTitle: '更換品項',
          submitFunc: 'handleSelectReplaceItem',
          style: {
            width: '520px',
            height: '560px',
          },
        },
        moreSize: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'moreSize',
          dialogTitle: '容量',
          dialogList: getDetailBtns.value.size?.slice(7),
          submitFunc: 'handleMoreSize',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: getDetail.value.size,
          },
        },
        moreTemperature: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'moreTemperature',
          dialogTitle: '冷熱',
          dialogList: getDetailBtns.value.temperature?.slice(7),
          submitFunc: 'handleMoreTemperature',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: getDetail.value.temperature,
          },
        },
        moreSweetness: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'moreSweetness',
          dialogTitle: '甜度',
          dialogList: getDetailBtns.value.sweetness?.slice(7),
          submitFunc: 'handleMoreSweetness',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: getDetail.value.sweetness,
          },
        },
        moreAddOn: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'moreAddOn',
          dialogTitle: '全部加料',
          dialogList: getAllAddOnList.value,
          submitFunc: 'handleMoreAddOn',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            type: 'multiple',
            init: getDetail.value.add_on,
          },
        },
        editAddOn: {
          dialogTemplate: 'EditAddOn',
          dialogName: 'editAddOn',
          dialogTitle: '編輯加料',
          dialogList: getDetail.value.add_on,
          submitFunc: 'handleEditAddOn',
          style: {
            width: '480px',
            height: 'auto',
          },
        },
        //容量價格選擇
        selectPrice: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'selectPrice',
          submitFunc: 'handleSelectPrice',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            init: getItemPrice.value,
          },
        },
        customPrice: {
          dialogTemplate: 'Computer',
          dialogName: 'customPrice',
          dialogTitle: '自訂金額',
          submitFunc: 'handleCustomPrice',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: getItemPrice.value,
            hasHundred: true,
          },
        },
        discount: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'discount',
          dialogTitle: '折扣', //品項折扣
          dialogList: getDiscountList.value,
          submitFunc: 'handleDiscount',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            type: 'multiple',
            init: chooseDiscount.value?.map((e) => (e.value ? e.value : e)),
          },
        },
        itemNote: {
          dialogTemplate: 'InputInfo',
          dialogName: 'itemNote',
          dialogTitle: '商品備註', //品項備註
          submitFunc: 'handleNote',
          style: {
            height: 'auto',
          },
          cusProps: {
            init: getNote.value,
          },
        },
        //結帳畫面相關彈窗-------------------------------------------------------
        //卡片支付和其他支付彈窗
        chooseMorePay: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'chooseMorePay',
          submitFunc: 'handleChoosePay',
          style: {
            width: '520px',
            height: '560px',
          },
        },
        enterCode: {
          dialogTemplate: 'inputInfo',
          dialogName: 'enterCode',
          dialogTitle: '手動輸入',
          submitFunc: 'handleEnterCode',
          style: {
            height: 'auto',
          },
        },
        entertain: {
          dialogTemplate: 'MoreSelect',
          dialogName: 'entertain',
          dialogTitle: '折扣', //整單折扣
          dialogList: getEntertainList.value,
          submitFunc: 'handleEntertain',
          style: {
            width: '520px',
            height: '560px',
          },
          cusProps: {
            type: 'multiple',
            init: chooseEntertain.value?.map((e) => (e.value ? e.value : e)),
          },
        },
        memo: {
          dialogTemplate: 'InputInfo',
          dialogName: 'memo',
          dialogTitle: '訂單備註', //整單備註
          submitFunc: 'handleMemo',
          style: {
            height: 'auto',
          },
          cusProps: {
            init: getMemo.value,
          },
        },
        buyerTaxId: {
          dialogTemplate: 'Information',
          dialogName: 'buyerTaxId',
          dialogTitle: '統編',
          dialogContent: getTax.value,
          submitFunc: 'clearTax',
          style: {
            height: '300px',
          },
        },
        bagQuantity: {
          dialogTemplate: 'Computer',
          dialogName: 'quantity',
          dialogTitle: '購物袋數量',
          submitFunc: 'handleBag',
          style: {
            width: '340px',
            height: '580px',
          },
        },
        redeemBonus: {
          dialogTemplate: 'RedeemBonus', //來店禮
          dialogName: 'redeemBonus',
          submitFunc: 'handleRedeemBonus',
          hideClose: true,
          style: {
            width: '480px',
            height: 'auto',
          },
        },
      };
    });
    return data.value[val];
  };

  //!掛單/內部訂單/訂單管理/交班等 相關彈窗資料 ---------------------------------------------------------
  const openHeaderDialog = (dialogName, cusProps = {}, newDialogData) => {
    closeDialog();
    const data = getHeaderDialogData(dialogName);
    if (data.cusProps) {
      data.cusProps = { ...data.cusProps, ...cusProps };
    } else {
      data.cusProps = cusProps;
    }
    if (newDialogData) {
      if (newDialogData.dialogTitle) data.dialogTitle = newDialogData.dialogTitle;
      if (newDialogData.dialogContent) data.dialogContent = newDialogData.dialogContent;
      if (newDialogData.dialogImage) data.dialogImage = newDialogData.dialogImage;
      if (newDialogData.submitFunc) data.submitFunc = newDialogData.submitFunc;
      if (newDialogData.hideClose) data.hideClose = newDialogData.hideClose;
      if (newDialogData.dialogList) data.dialogList = newDialogData.dialogList;
      if (newDialogData.style) data.style = newDialogData.style;
    }
    doOpenDialog(data);
  };
  const getHeaderDialogData = (val) => {
    const data = computed(() => {
      return {
        // 查看訂單的詳細
        buyerInfo: {
          dialogTemplate: 'Information',
          dialogName: 'buyerInfo',
          dialogTitle: '訂購人資訊',
          style: {
            height: 'auto',
          },
        },
        // 內部訂單------------------------------------------
        reject: {
          dialogTemplate: 'RejectOrder',
          dialogName: 'reject',
          dialogTitle: '拒單原因',
          submitFunc: 'handleRejectOrder',
          style: {
            height: 'auto',
          },
        },
        // 外部訂單拒單------------------------------------------
        rejectOutsideOrder: {
          dialogTemplate: 'RejectOrder',
          dialogName: 'reject',
          dialogTitle: '拒單',
          submitFunc: 'handleRejectOrder',
          style: {
            height: 'auto',
          },
        },
        // 訂單管理------------------------------------------
        dateRangePicker: {
          dialogTemplate: 'DateRangePicker',
          dialogName: 'dateRangePicker',
          dialogTitle: '自訂時間',
          submitFunc: 'handleDateRangePicker',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: proxy.search?.date_range, //data in AdvancedSearch.vue
          },
        },
        inputSerialNo: {
          dialogTemplate: 'NumberLimitInput',
          dialogTitle: '訂單序號',
          dialogName: 'inputSerialNo',
          submitFunc: 'handleInputAttesting',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            limit: 11,
            init: proxy.search?.serial_no, //data in AdvancedSearch.vue
          },
        },
        inputInvoice: {
          dialogTemplate: 'NumberLimitInput',
          dialogTitle: '發票號碼',
          dialogName: 'inputInvoice',
          submitFunc: 'handleInputAttesting',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            limit: 8,
            init: proxy.search?.invoice_no, //data in AdvancedSearch.vue
          },
        },
        // voidOrder: {
        //   dialogTemplate: 'InputInfo',
        //   dialogName: 'voidOrder',
        //   dialogTitle: '執行作廢',
        //   submitFunc: 'handleVoidOrder',
        //   style: {
        //     height: 'auto',
        //   },
        //   cusProps: {
        //     init: {
        //       account: '',
        //       password: '',
        //     },
        //   },
        // },
        // 訊息通知------------------------------------------
        notificationContent: {
          dialogTemplate: 'Information',
          dialogName: 'notificationContent',
          dialogTitle: '通知內容',
          style: {
            height: 'auto',
            minHeight: '400px',
          },
        },
        //交班清帳------------------------------------------
        inputCashBox: {
          dialogTemplate: 'Computer',
          dialogName: 'inputCashBox',
          dialogTitle: '抽屜現金',
          submitFunc: 'handleCashBox',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: proxy.cashBox, //data in Shift.vue
            hasHundred: true,
          },
        },
      };
    });
    return data.value[val];
  };

  //提供給子元素參數
  provide('dialogVisible', dialogVisible);
  provide('name', dialogName);
  provide('close', closeDialog);
  provide('submit', submit);
  provide('openDialog', openDialog);
  provide('title', title);
  provide('content', content);
  provide('image', image);
  provide('hideClose', hideClose);
  provide('list', listData);
  provide('style', styleData);
  provide('cusProps', cus);

  return {
    dialogVisible,
    dialogTemplate,
    dialogName,
    openDialog,
    doOpenDialog,
    closeDialog,
    getDialogData,
    openHeaderDialog,
    getHeaderDialogData,
  };
};

export { useDialog };

/* 
TODO --- 建立dialog in dialog ---
!由於Dialog無法同時開啟兩個，此封裝方法可以在dialog內開啟另一個內部dialog且原dialog不會關閉
!使用方法與useDialog相同，只需注意return的參數與inject的參數都會加上inner

*在getInnerDialogData建立資料 ---
[dialogName]:{
  dialogTemplate: vue檔名 / 模板
  dialogName: unique name，以方便在dialog template模板中做個別處理
  dialogTitle: 標題名,inject('inner_title')
  dialogContent: 內文,inject('inner_content')
  dialogImage: 圖片,inject('inner_image')
  dialogList: 陣列,inject('inner_list'),需解構{ list }
  submitFunc: 自定義的methods function/需搭配dialog的submit使用
  style: {
    width: 寬度,預設400px
    height: 高度,預設400px
    dialogRows: 可設定grid-rows(string), 預設為(50px auto 60px)(title-body-footer)
  }
  cusProps: 自定義其他屬性,inject('inner_cusProps'),需解構{ cusProps }
  hideClose: 要不要顯示叉叉關閉(預設false)
}
!以上只有dialogTemplate必填，其他皆選填


*使用dialog ---
1. import dialogTemplate.vue ： component: { dialogTemplate }
!dialogTemplate.vue必須使用<cus-dialog-in-dialog></cus-dialog-in-dialog>建立內容
2. import { useDialogInDialog }
3. 在setup()執行useDialogInDialog() 
可解構的參數有{ 
    inner_dialogVisible,
    inner_dialogTemplate,
    inner_dialogName,
    openInnerDialog,
    doOpenInnerDialog,
    closeInnerDialog,
    getInnerDialogData, }
inner_dialogVisible: 控制dialog開關的boolean值
inner_dialogTemplate: 在template中使用：<component :is="inner_dialogTemplate"></component> 控制使用哪個模板
inner_dialogName: unique name，可以用此判斷目前是使用哪個dialog
openInnerDialog: function，需帶入自定義的參數(dialogName)
doOpenInnerDialog: function，如果需要動態增加dialog參數，須先使用getInnerDialogData獲取已設定data並新增參數，再使用doOpenInnerDialog開啟彈窗並帶入新的data
getInnerDialogData: function，執行getInnerDialogData()帶入自定義的dialogName，可獲取設定的dialog資料
closeInnerDialog: function，可關閉彈窗
!以上inner_dialogTemplate,openInnerDialog, 必須return，其餘有使用到再return即可


* 使用submitFunc ---
在子元素的dialog.vue的setup() inject('inner_submit')
子元素執行submit(val) 等同 父元素執行submitFunc(val)

*/

const useDialogInDialog = () => {
  //建立參數
  const inner_dialogVisible = ref(false);
  const inner_dialogTemplate = ref(null);
  const inner_dialogName = ref(null);
  const title = ref(null);
  const content = ref(null);
  const image = ref(null);
  const funcName = ref(null);
  const hideClose = ref(false);
  let listData = reactive({});
  let styleData = reactive({});
  let cus = reactive({});
  let chooseVal = reactive({});
  //打開彈窗
  const doOpenInnerDialog = (dialog) => {
    // console.log(dialog);
    inner_dialogTemplate.value = dialog.dialogTemplate;
    inner_dialogName.value = dialog.dialogName;
    title.value = dialog.dialogTitle;
    content.value = dialog.dialogContent;
    image.value = dialog.dialogImage;
    funcName.value = dialog.submitFunc;
    hideClose.value = dialog.hideClose;
    listData.list = dialog.dialogList;
    styleData.style = dialog.style;
    cus.cusProps = dialog.cusProps;
    inner_dialogVisible.value = true;
  };
  const openInnerDialog = (dialogName, cusProps = {}, newDialogData) => {
    closeInnerDialog();
    const data = getInnerDialogData(dialogName);
    if (data.cusProps) {
      data.cusProps = { ...data.cusProps, ...cusProps };
    } else {
      data.cusProps = cusProps;
    }
    if (newDialogData) {
      if (newDialogData.dialogTitle) data.dialogTitle = newDialogData.dialogTitle;
      if (newDialogData.dialogContent) data.dialogContent = newDialogData.dialogContent;
      if (newDialogData.dialogImage) data.dialogImage = newDialogData.dialogImage;
      if (newDialogData.submitFunc) data.submitFunc = newDialogData.submitFunc;
      if (newDialogData.hideClose) data.hideClose = newDialogData.hideClose;
      if (newDialogData.dialogList) data.dialogList = newDialogData.dialogList;
      if (newDialogData.style) data.style = newDialogData.style;
    }
    doOpenInnerDialog(data);
  };
  //關閉彈窗
  const closeInnerDialog = () => {
    inner_dialogTemplate.value = null;
    inner_dialogVisible.value = false;
  };
  //彈窗內執行submit
  const { proxy } = getCurrentInstance();
  const submit = (val) => {
    // chooseVal.data = 'chooseValIsChange';
    chooseVal.data = val;
    proxy[funcName.value](chooseVal.data);
  };
  //提供給子元素參數
  provide('inner_dialogVisible', inner_dialogVisible);
  provide('inner_name', inner_dialogName);
  provide('inner_close', closeInnerDialog);
  provide('inner_submit', submit);
  provide('openInnerDialog', openInnerDialog);
  provide('inner_title', title);
  provide('inner_content', content);
  provide('inner_image', image);
  provide('inner_hideClose', hideClose);
  provide('inner_list', listData);
  provide('inner_style', styleData);
  provide('inner_cusProps', cus);
  const getInnerDialogData = (val) => {
    const data = computed(() => {
      return {
        //瀏覽內的品項詳細
        menuDetail: {
          dialogTemplate: 'MenuDetailInDialog',
          dialogName: 'menuDetail',
        },
        //瀏覽內的訂單資訊
        orderInfo: {
          dialogTemplate: 'OrderInfoInDialog',
          dialogName: 'orderInfo',
        },
        //進階搜尋
        advancedSearch: {
          dialogTemplate: 'AdvancedSearch',
          dialogName: 'advancedSearch',
          submitFunc: 'handleSearchOrder',
        },
        //訂購人電話
        inputTel: {
          dialogTemplate: 'StringNumberInput',
          dialogName: 'inputTel',
          dialogTitle: '訂購人電話',
          submitFunc: 'handleUserTel',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: proxy.input?.order_user_tel, //data in inputInfo.vue
            limit: 10,
          },
        },
        // 訂購人資訊的時間選擇彈窗
        timePicker: {
          dialogTemplate: 'TimePicker',
          dialogName: 'timePicker',
          dialogTitle: '取餐時間',
          submitFunc: 'handleTime',
          style: {
            width: '340px',
            height: '580px',
          },
        },
        // 訂購人資訊的平台號碼
        inputOutsideId: {
          dialogTemplate: 'StringNumberInput',
          dialogName: 'inputOutsideId',
          submitFunc: 'handleOutsideId',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            init: proxy.input?.outside_order_id, //data in inputInfo.vue
            limit: 8,
          },
        },
        // 交班清帳的雜支項目
        costList: {
          dialogTemplate: 'CostList',
          dialogName: 'costList',
          dialogTitle: '雜支項目',
          submitFunc: 'handleCostList',
          style: {
            width: '100%',
            height: '99vh',
          },
          cusProps: {
            init: proxy.cost, //data in Shift.vue
          },
        },
        //輸入旺卡卡號
        inputCardNo: {
          dialogTemplate: 'StringNumberInput',
          dialogName: 'inputCardNo',
          dialogTitle: '旺卡卡號',
          submitFunc: 'handleCardNo',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            limit: 14,
          },
        },
        //補印發票
        reprintInvoice: {
          dialogTemplate: 'ReprintInvoice',
          dialogTitle: '補印發票',
          dialogName: 'reprintInvoice',
          style: {
            width: '480px',
            height: 'auto',
          },
        },
        //掛單--------------------------------------
        //搜尋取餐號
        searchOutsideId: {
          dialogTemplate: 'StringNumberInput',
          dialogTitle: '取餐號',
          dialogName: 'searchOutsideId',
          submitFunc: 'handleSearchOutsideId',
          style: {
            width: '340px',
            height: '580px',
          },
          cusProps: {
            limit: 8,
          },
        },
        //延遲訂單
        delay: {
          dialogTemplate: 'DelayOrder',
          dialogName: 'delay',
          dialogTitle: '延遲訂單',
          submitFunc: 'handleDelayOrder',
          style: {
            height: 'auto',
          },
          cusProps: {
            order_take_time: proxy.selectOrder?.order_take_time, //data in PendingOrder.vue
          },
        },
        setting: {
          dialogTemplate: 'Setting',
          dialogName: 'setting',
          dialogTitle: '設定',
          style: {
            width: '480px',
            height: 'auto',
          },
        },
        updating: {
          dialogTemplate: 'Updating',
          dialogName: 'updating',
          dialogTitle: '更新',
          style: {
            width: '480px',
            height: 'auto',
          },
        },
      };
    });
    return data.value[val];
  };
  return {
    inner_dialogVisible,
    inner_dialogTemplate,
    inner_dialogName,
    openInnerDialog,
    doOpenInnerDialog,
    closeInnerDialog,
    getInnerDialogData,
  };
};

export { useDialogInDialog };
